import React, { Suspense, lazy } from 'react';

/**
 * React 18 replacement for react-loadable.
 */
export default function lazyLoad(importFn, Fallback) {
	const LazyComponent = lazy(importFn);

	function LazyWrapper(props) {
		return (
			<Suspense fallback={<Fallback />}>
				<LazyComponent {...props} />
			</Suspense>
		);
	}

	LazyWrapper.preload = importFn;

	return LazyWrapper;
}
